import { Devices40 as o } from "./devices-40/index.js";
import { Extra48 as r } from "./extra-48/index.js";
import { Financial as m } from "./financial/index.js";
import { FoodAndDrink as i } from "./food-and-drinks/index.js";
import { Hands as t } from "./hands/index.js";
import { Leisure as p } from "./leisure/index.js";
import { LocationsAndTransport as n } from "./locations-and-transport/index.js";
import { Products as f } from "./products/index.js";
import { UiAndPeople as a } from "./ui-and-people/index.js";
import { TechnologyAndHardware as e } from "./technology-and-hardware/index.js";
import { Various40 as s } from "./various-40/index.js";
const T = {
  Devices40: o,
  Extra48: r,
  Financial: m,
  FoodAndDrink: i,
  Hands: t,
  Leisure: p,
  LocationsAndTransport: n,
  Products: f,
  UiAndPeople: a,
  TechnologyAndHardware: e,
  Various40: s
};
export {
  T as Icons40
};
